// rafce
import React from 'react'
import Header from '../header/Header'; // ✅ matches file name exactly
import './hero.css'; // ✅ matches file name exactly
import Heart from '../../assets/heart.png'; // ✅ matches file name exactly
import hero_image from '../../assets/hero_image.png'; // ✅ matches file name exactly
import hero_image_back from '../../assets/hero_image_back.png'; // ✅ matches file name exactly
import Calories from '../../assets/calories.png'; // ✅ matches file name exactly
import { motion } from 'framer-motion'; // ✅ matches package name exactly 156
import NumberCounter from 'number-counter'; // ✅ matches package name exactly 156
// ✅ matches file name exactly
const hero = () => {
    const transition = { type: 'spring', duration: 3 };
    const mobile = window.innerWidth <= 768 ? true : false;// ✅ matches variable name exactly
    return (
        <div className='hero' id='Home'>
            {/* div.lrb */}
            <div className="blur hero-blur"></div>
            <div className='left-h'>
                <Header />
                <div
                    className="the-best-ad">
                    <motion.div
                        initial={{ left: mobile ? "178px" : '238px' }}
                        whileInView={{ left: "8px" }}
                        transition={{ ...transition, type: "tween" }}
                    ></motion.div>
                    <span>the best fitness club in the town </span>

                </div>

                {/*  the hero text */}
                <div className="hero-text">
                    <div>
                        <span className="stroke-text">Shape </span>
                        <span>Your</span>
                    </div>
                    <div>
                        <span>Ideal body</span>
                    </div>
                    <div>
                        <span>
                            In here we will help you to shape and build your ideal body and
                            live up your life to fullest
                        </span>
                    </div>
                </div>
                <div className=" figure">
                    <div>
                        <span>
                            <NumberCounter end={140} start={100} delay={4} preFix="+" />
                        </span>
                        <span>expert coaches</span>
                    </div>
                    <div>
                        <span>
                            <NumberCounter end={978} start={878} delay={4} preFix="+" />
                        </span>
                        <span>Members joined</span>
                    </div>
                    <div>
                        <span>
                            <NumberCounter end={50} delay={2} preFix="+" />
                        </span>
                        <span>fitness programs</span>
                    </div>

                </div>
                <div className="hero-buttom">
                    <div className="buttons btn">get started</div>
                    <div className="buttons btn">learn more</div>
                </div>

            </div>

            <div className="right-h">
                <div className="btn1 ">join now</div>
                <div className="heart-rate">
                    <img src={Heart} alt="" />
                    <span>Heart Rate</span>
                    <span> 110 bpm</span>
                </div>
                {/* hero img  style={{ width: "550px", height: "550px" }}*/}
                <div className="hero-img">
                    <img src={hero_image} alt="Person lifting weights in the gym" style={{ width: "450px", height: "450px" }} />
                </div>
                <motion.div
                    initial={{ right: "-1rem" }}
                    whileInView={{ right: "7rem" }}
                    transition={transition}
                    className="hero-img-back">
                    <img src={hero_image_back} alt="" style={{ width: "450px", height: "450px" }} />
                </motion.div>

                <motion.div
                    initial={{ right: "-1rem" }}
                    whileInView={{ right: "30rem" }}
                    transition={transition}
                    className="calories">
                    <img src={Calories} alt="" />
                    <div>
                        <span>Calories Burned</span>
                        <span>220 kcal</span>
                    </div>
                </motion.div>
            </div>
        </div >
    )
}

export default hero
